/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
-----------------------------------------------------------------------------*/

<template>
  <div v-if="basePageLoaded">
    <section aria-labelledby="emailNotifications">
      <h1 id="emailNotifications">
        Email Notifications
      </h1>
      <p>
        Use the form below to sign up to receive email notifications triggered by various
        events associated with your VoiceVibes account.
        <br>
      </p>
      <form @submit.prevent="update">
        <table
          style="width: 100%"
          class="table"
        >
          <tr v-if="showManagerEmailNotifications">
            <td
              scope="col"
              colspan="3"
            >
              <h2>Coach Notifications</h2>
            </td>
          </tr>
          <tr v-if="showManagerEmailNotifications">
            <th scope="col">
              Event
            </th>
            <th
              colspan="2"
              style="padding-left: 50px;"
              scope="col"
            >
              Send Emails?
            </th>
          </tr>
          <tr v-if="showManagerEmailNotifications && assignmentsEnabled">
            <td
              v-if="assignmentsEnabled"
              scope="row"
            >
              <strong>Recording Flagged for Review</strong> &mdash;
              Receive an email when a speaker
              flags a recording for review. The email contains a link to view the flagged recording.
            </td>
            <td
              v-else
              scope="row"
            >
              <strong>Recording Submitted to {{ isEdu ? 'Instructor' : 'Coach' }}</strong> &mdash;
              Receive an email when a {{ (isEdu) ? 'student' : 'speaker' }}
              submits a recording to you. The email contains a link to view the submitted recording.
            </td>
            <td>
              <label
                for="recordingSubmittedFrequencyOff"
                class="radio-inline"
              >
                <input
                  id="recordingSubmittedFrequencyOff"
                  v-model="formValues.recordingSubmittedFrequency"
                  type="radio"
                  name="recordingSubmittedFrequency"
                  value="0"
                  tabindex="0"
                >
                Off
              </label>
            </td>
            <td>
              <label
                for="recordingSubmittedFrequencyImmediate"
                class="radio-inline"
              >
                <input
                  id="recordingSubmittedFrequencyImmediate"
                  v-model="formValues.recordingSubmittedFrequency"
                  type="radio"
                  name="recordingSubmittedFrequency"
                  value="1"
                  tabindex="0"
                >
                On
              </label>
            </td>
            <!--
            <td>
              <label for="recordingSubmittedFrequencyBatched" class="radio-inline">
                <input type="radio" id="recordingSubmittedFrequencyBatched" name="recordingSubmittedFrequency"
                       value="2" v-model="formValues.recordingSubmittedFrequency">
                Batched
              </label>
            </td>
            -->
          </tr>
          <tr v-if="showManagerEmailNotifications && assignmentsEnabled">
            <td scope="row">
              <strong>Assignment Completed</strong> &mdash; Receive an email when a speaker
              completes an assignment.
            </td>
            <td>
              <label
                for="assignmentCompletedFrequencyOff"
                class="radio-inline"
              >
                <input
                  id="assignmentCompletedFrequencyOff"
                  v-model="formValues.assignmentCompletedFrequency"
                  type="radio"
                  name="assignmentCompletedFrequency"
                  value="0"
                  tabindex="0"
                >
                Off
              </label>
            </td>
            <td>
              <label
                for="assignmentCompletedFrequencyImmediate"
                class="radio-inline"
              >
                <input
                  id="assignmentCompletedFrequencyImmediate"
                  v-model="formValues.assignmentCompletedFrequency"
                  type="radio"
                  name="assignmentCompletedFrequency"
                  value="1"
                  tabindex="0"
                >
                On
              </label>
            </td>
            <!--
            <td>
              &nbsp;
            </td>
            -->
          </tr>
          <tr v-if="showManagerEmailNotifications">
            <td scope="row">
              <strong>Recording Feedback Received &mdash;</strong>
              Receive an email when a {{ (isEdu) ? 'student' : 'speaker' }} leaves feedback on a recording.
              The email contains the text of the feedback and a link to view
              the associated recording.
            </td>
            <td>
              <label
                for="feedbackReceivedFrequencyOff"
                class="radio-inline"
              >
                <input
                  id="feedbackReceivedFrequencyOff"
                  v-model="formValues.feedbackReceivedFrequency"
                  type="radio"
                  name="feedbackReceivedFrequency"
                  value="0"
                  tabindex="0"
                >
                Off
              </label>
            </td>
            <td>
              <label
                for="feedbackReceivedFrequencyImmediate"
                class="radio-inline"
              >
                <input
                  id="feedbackReceivedFrequencyImmediate"
                  v-model="formValues.feedbackReceivedFrequency"
                  type="radio"
                  name="feedbackReceivedFrequency"
                  value="1"
                  tabindex="0"
                >
                On
              </label>
            </td>
            <!--
            <td>
              <label for="feedbackReceivedFrequencyBatched" class="radio-inline">
                <input type="radio" id="feedbackReceivedFrequencyBatched" name="feedbackReceivedFrequency"
                       value="2" v-model="formValues.feedbackReceivedFrequency">
                Batched
              </label>
            </td>
            -->
          </tr>
          <tr v-if="showSpeakerEmailNotifications">
            <td
              scope="col"
              colspan="3"
            >
              <h2>Speaker Notifications</h2>
            </td>
          </tr>
          <tr v-if="showSpeakerEmailNotifications">
            <th scope="col">
              Event
            </th>
            <th
              colspan="2"
              style="padding-left: 50px;"
              scope="col"
            >
              Send Emails?
            </th>
          </tr>
          <tr v-if="showSpeakerEmailNotifications && assignmentsEnabled">
            <td scope="row">
              <strong>Assignment Received</strong> &mdash; Receive an email when your
              coach has given you a new assignment.
            </td>
            <td>
              <label
                for="assignmentReceivedFrequencyOff"
                class="radio-inline"
              >
                <input
                  id="assignmentReceivedFrequencyOff"
                  v-model="formValues.assignmentReceivedFrequency"
                  type="radio"
                  name="assignmentReceivedFrequency"
                  value="0"
                  tabindex="0"
                >
                Off
              </label>
            </td>
            <td>
              <label
                for="assignmentReceivedFrequencyImmediate"
                class="radio-inline"
              >
                <input
                  id="assignmentReceivedFrequencyImmediate"
                  v-model="formValues.assignmentReceivedFrequency"
                  type="radio"
                  name="assignmentReceivedFrequency"
                  value="1"
                  tabindex="0"
                >
                On
              </label>
            </td>
            <!--
            <td>
              &nbsp;
            </td>
            -->
          </tr>
          <tr v-if="showSpeakerEmailNotifications && !showManagerEmailNotifications">
            <td scope="row">
              <strong>Recording Feedback Received &mdash;</strong>
              Receive an email when someone leaves feedback on one
              of your recordings. The email contains the text of the feedback and a link to view
              the recording.
            </td>
            <td>
              <label
                for="feedbackReceivedFrequencyOff"
                class="radio-inline"
              >
                <input
                  id="feedbackReceivedFrequencyOff"
                  v-model="formValues.feedbackReceivedFrequency"
                  type="radio"
                  name="feedbackReceivedFrequency"
                  value="0"
                  tabindex="0"
                >
                Off
              </label>
            </td>
            <td>
              <label
                for="feedbackReceivedFrequencyImmediate"
                class="radio-inline"
              >
                <input
                  id="feedbackReceivedFrequencyImmediate"
                  v-model="formValues.feedbackReceivedFrequency"
                  type="radio"
                  name="feedbackReceivedFrequency"
                  value="1"
                  tabindex="0"
                >
                On
              </label>
            </td>
            <!--
            <td>
              <label for="feedbackReceivedFrequencyBatched" class="radio-inline">
                <input type="radio" id="feedbackReceivedFrequencyBatched" name="feedbackReceivedFrequency"
                       value="2" v-model="formValues.feedbackReceivedFrequency">
                Batched
              </label>
            </td>
            -->
          </tr>
          <tr v-if="showManagerEmailNotifications || showSpeakerEmailNotifications">
            <td scope="row">
              <strong>Recording Shared with Entire {{ (isEdu) ? 'Class' : 'Group' }} &mdash;</strong>
              Receive an email when a recording is shared with the entire {{ (isEdu) ? 'class' : 'group' }}.
              The email contains a link to view the recording.
            </td>
            <td>
              <label
                for="recordingSharedFrequencyOff"
                class="radio-inline"
              >
                <input
                  id="recordingSharedFrequencyOff"
                  v-model="formValues.recordingSharedFrequency"
                  type="radio"
                  name="recordingSharedFrequency"
                  value="0"
                  tabindex="0"
                >
                Off
              </label>
            </td>
            <td>
              <label
                for="recordingSharedFrequencyImmediate"
                class="radio-inline"
              >
                <input
                  id="recordingSharedFrequencyImmediate"
                  v-model="formValues.recordingSharedFrequency"
                  type="radio"
                  name="recordingSharedFrequency"
                  value="1"
                  tabindex="0"
                >
                On
              </label>
            </td>
            <!--
            <td>
              <label for="recordingSharedFrequencyBatched" class="radio-inline">
                <input type="radio" id="recordingSharedFrequencyBatched" name="recordingSharedFrequency"
                       value="2" v-model="formValues.recordingSharedFrequency">
                Batched
              </label>
            </td>
            -->
          </tr>
          <tr v-if="showSpeakerEmailNotifications">
            <td scope="row">
              <strong>Recording Processed / Email Scores</strong> &mdash; Receive an email containing
              a summary of your scores when you add a new recording.
            </td>
            <td>
              <label
                for="recordingProcessedFrequencyOff"
                class="radio-inline"
              >
                <input
                  id="recordingProcessedFrequencyOff"
                  v-model="formValues.recordingProcessedFrequency"
                  type="radio"
                  name="recordingProcessedFrequency"
                  value="0"
                  tabindex="0"
                >
                Off
              </label>
            </td>
            <td>
              <label
                for="recordingProcessedFrequencyImmediate"
                class="radio-inline"
              >
                <input
                  id="recordingProcessedFrequencyImmediate"
                  v-model="formValues.recordingProcessedFrequency"
                  type="radio"
                  name="recordingProcessedFrequency"
                  value="1"
                  tabindex="0"
                >
                On
              </label>
            </td>
            <!--
            <td>
              &nbsp;
            </td>
            -->
          </tr>
        </table>
        <br><br>
        <loading-button :loading="saving">
          Save
        </loading-button>
        <br><br>
      </form>
    </section>
  </div>
</template>

<style lang="less" scoped>
  table {
    th {
      padding-left: 10px;
    }
    tr {
      border-bottom: 1px solid #28275B;
    }
    td {
      padding: 20px;
    }
    tr td:first-child {
      width: 50%;
    }
    tr td:nth-child(2) {
      width: 15%;
    }
    tr td:nth-child(3) {
      width: 35%;
    }
    tr td {
      text-align: left;
    }
  }
</style>


<script>
import BasePage from './BasePage.js';

export default {
  mixins: [BasePage],
  props: {groups: Object},
  data() {
    return {
      saving: false,
    };
  },
  computed: {
    formValues() {
      let user = this.$store.getters.user;
      if (!user) {
        user = {
          recordingSubmittedFrequency: 0,
          feedbackReceivedFrequency: 0,
          recordingProcessedFrequency: 0,
          recordingSharedFrequency: 0,
          assignmentReceivedFrequency: 0,
          assignmentCompletedFrequency: 0,
        };
      }

      return {
        recordingSubmittedFrequency: user.recordingSubmittedFrequency,
        feedbackReceivedFrequency: user.feedbackReceivedFrequency,
        recordingProcessedFrequency: user.recordingProcessedFrequency,
        recordingSharedFrequency: user.recordingSharedFrequency,
        assignmentReceivedFrequency: user.assignmentReceivedFrequency,
        assignmentCompletedFrequency: user.assignmentCompletedFrequency,
      };
    },
    showSpeakerEmailNotifications() {
      if (!this.isSpeaker) {
        return false;
      }
      const org = this.$store.getters.org;
      return (org && typeof org.settings !== 'undefined' && org.settings.Email_Notifications_For_Speakers);
    },
    showManagerEmailNotifications() {
      if (!this.isGroupManager) {
        return false;
      }
      const org = this.$store.getters.org;
      return (org && typeof org.settings !== 'undefined' && org.settings.Email_Notifications_For_Managers);
    },
  },
  created() {
  },
  methods: {
    update() {
      this.$store.dispatch('updateUserEmailPreferences', this.formValues)
        .then(() => {
          // Vue doesn't auto-update the nav link for whatever reason
          this.$store.dispatch('notify', {
            type: 'success',
            subject: 'Changes Saved',
            text: 'Your changes have been saved.'
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  }
};
</script>
